export default "__VITE_ASSET__cb2ad5a7__"